import phoneTypes from '../../enums/phoneTypes';

export default {
  [phoneTypes.business]: 'Business Phone',
  [phoneTypes.extension]: 'Extension Phone',
  [phoneTypes.home]: 'Home Phone',
  [phoneTypes.mobile]: 'Mobile Phone',
  [phoneTypes.phone]: 'Phone',
  [phoneTypes.unknown]: 'Unknown Phone Type',
};
